<app-loader *ngIf="isLoading"></app-loader>
<div class="d-flex justify-content-between align-items-center mb-3">
    <div>
        <h4 class="q-heading">
            <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
                    class="me-2 cursor-pointer" /></span>
            {{ "MANAGEDEVICE.GIVEARING" | translate }}
        </h4>
    </div>
    <div>
        <form [formGroup]="restorePublishForm">
            <select class="form-select bg-transparent" formControlName="mobileDeviceName"
                (change)="onMobileDeviceSelect($event)">
                <option *ngFor="let item of mobileDevice" [value]="item.id">
                    {{ item.deviceName }}
                </option>
            </select>
        </form>
    </div>
</div>
<div class="commandsBG-WHITE mb-5 mb-md-0 text-center">
    <div class="row">
        <div class="col-md-12 mb-3">
            <img src="./assets/images/RINGDEVICE.svg" class="w-200" alt="" />
        </div>

        <ul class="list-unstyled">
            <li>
                <p>
                    <strong>{{ "MANAGEDEVICE.GIVEARING" | translate }}</strong>
                </p>
            </li>
            <li>
                <span>
                    {{ "MANAGEDEVICE.RINGTEXT1" | translate }}
                </span>
            </li>
            <li>
                <span>
                    {{ "MANAGEDEVICE.RINGTEXT2" | translate }}
                </span>
            </li>
        </ul>
    </div>
    <ng-container *ngIf="errorMessage">
        <p class="errMessage">{{ errorMessage }}</p>
    </ng-container>

    <div class="row mb-0 mb-md-5">
        <div class="col-md-12">
            <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="sendCommand()">
                {{ "MANAGEDEVICE.RINGDEVICE" | translate }}
            </button>
        </div>
        <div class="col-md-12">
        </div>
    </div>
</div>

<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="LockPopup"
    data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
        <div class="modal-content border-none shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
            <ng-container *ngIf="!isRing">
                <div class="mt-5">
                    <img src="../../../assets/images/main-ringdevice.svg" alt="" class="mx-auto" height="35px"
                        width="35px" />
                </div>
                <h4 class="q-modal-heading mt-2 fw-bold">
                    {{ "MANAGEDEVICE.RINGINITIATED" | translate }}
                </h4>
                <div class="text-center mb-4 mt-3 d-flex justify-content-center">
                    <div class="me-3">
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>